import { useParams } from "react-router-dom";
import React, { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import AccountHeader from "../../../Component/Header/account_header"
import { ApiService } from "../../../Component/services/apiServices";
import Footer from "../../../Component/Footer";

const Orderdetails = () => {
    const { id } = useParams()
    const [OrderData, setOrderdata] = useState()
    const [showskeleton, setshowskeleton] = useState(true)
    const [OrderStatus, setOrderStatus] = useState({})
    const [multipleorderdetail, setmultipleorderdetail] = useState({})
    const didMountRef = useRef(true)
    const getOrderDetails = useCallback(() => {
        const dataString = {
            trans_order_number: id
        }
        ApiService.postData('/order-details', dataString).then(res => {
            if (res.status === 'success') {
                setOrderdata(res?.orderData)
                setmultipleorderdetail(res?.dayWiseItems)
                setOrderStatus(res?.orderStatus)
                setshowskeleton(false)
            } else if (res?.status === "session_expired") {
                localStorage.removeItem("USER_SESSION")
                setshowskeleton(false)
            } else {
                setshowskeleton(false)
            }
        })
    }, [id]);
    useEffect(() => {
        if (didMountRef.current) {
            getOrderDetails()
        }
        didMountRef.current = false;
    }, [getOrderDetails])


    const getOrderStatusText = (orderData) => {
        if (!orderData || typeof orderData.td_order_status !== "number") return "Unknown";
        return OrderStatus[orderData.td_order_status] || "Unknown";
    };

    const formatMobileNumber = (mobile) => {
        if (!mobile) return "N/A";
        return mobile.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
    };
    return (<>
        <AccountHeader heading={'Order Details'}></AccountHeader>
        <div id="appCapsule">
        <div className="mwapper p-10">
            {showskeleton ? (
                <Skeleton height={300} width={'100%'}></Skeleton>
            ) : (
                <div className="order-card">
                    <>
                        <h3 className="order-title">{OrderData?.trans_user_name ?? "N/A"}</h3>
                        <p className="order-info">
                            <strong>Email:</strong> {OrderData?.trans_user_email ?? "N/A"}
                        </p>
                        <p className="order-info">
                            <strong>Mobile:</strong> {OrderData?.trans_user_mobile ?? "N/A"}
                        </p>

                        <div className="order-divider"></div>

                        <p className="order-info">
                            <strong>Order ID:</strong> #{OrderData?.trans_order_number ?? "N/A"}
                        </p>
                        <p className="order-info">
                            <strong>Order Date:</strong>{" "}
                            {moment(OrderData?.created_at).format("MMM D, YYYY")}
                        </p>
                        <p className="order-info">
                            <strong>Order Type:</strong> {OrderData?.trans_delivery_type ?? "N/A"}
                        </p>

                        {OrderData?.trans_delivery_type === "Pickup" ? (
                            <>
                                <p className="order-info">
                                    <strong>Pickup Address:</strong> {OrderData?.trans_store_details?.store_address ?? "N/A"}
                                </p>
                                <p className="order-info">
                                    <strong>Phone Number:</strong> {formatMobileNumber(OrderData?.trans_store_details?.store_mobile)}
                                </p>
                            </>
                        ) : (
                            <p className="order-info">
                                <strong>Delivery Address:</strong> {OrderData?.trans_delivery_address ?? "N/A"}
                            </p>
                        )}
                    </>
                </div>
            )}
            <div className="card-table pt-10">
                {showskeleton ? <>
                    <Skeleton height={200} width={'100%'}></Skeleton>
                    <Skeleton height={200} width={'100%'}></Skeleton>
                    <Skeleton height={200} width={'100%'}></Skeleton>
                </> : <>
                    {multipleorderdetail && multipleorderdetail?.transDataByDay &&
                        Object.entries(multipleorderdetail?.transDataByDay).map(([keyDay, valueDay]) => (
                            valueDay.rowOrdersData.length > 0 && (
                                <div key={keyDay} className="mb-3">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center text-white mt-3 p-3 rounded" style={{ background: "#db2727" }}>
                                        <span className="fw-bold">{moment(keyDay).format("dddd, DD MMM YYYY")}</span>
                                        <button className="btn btn-sm text-light border border-white fw-bold">
                                            {getOrderStatusText(valueDay?.dayWiseStatusDate)}
                                        </button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered text-center">
                                            <thead className="text-white">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Image</th>
                                                    <th className="text-start">Item</th>
                                                    <th>Qty</th>
                                                    <th>Price</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {valueDay.rowOrdersData.map((valueItems, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <img src={valueItems.td_item_image} className="img-fluid rounded" style={{ width: "50px" }} alt="Item" />
                                                        </td>
                                                        <td className="text-start">
                                                            {valueItems.td_item_title} ({valueItems.td_meal_type === 1 ? "Dinner" : "Lunch"})
                                                        </td>
                                                        <td>{valueItems.td_item_qty}</td>
                                                        <td>${parseFloat(valueItems.td_item_net_price + valueItems.td_addon_total).toFixed(2)}</td>
                                                        <td>${(parseFloat(valueItems.td_item_net_price + valueItems.td_addon_total) * valueItems.td_item_qty).toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td colSpan="4"></td>
                                                    <td><strong>Sub Total</strong></td>
                                                    <td>${valueDay.dayWiseAmount.itemSubTotal.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="4"></td>
                                                    <td>Discount</td>
                                                    <td>${valueDay.dayWiseAmount.itemDiscount.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="4"></td>
                                                    <td>Add On</td>
                                                    <td>${valueDay.dayWiseAmount.itemAddOn.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="4"></td>
                                                    <td>Delivery Charges</td>
                                                    <td>${valueDay.dayWiseAmount.itemDeliveryCharges.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="4"></td>
                                                    <td>GST</td>
                                                    <td>${((valueDay.dayWiseAmount.itemFinalTotal * 10) / 100).toFixed(2)}</td>
                                                </tr>
                                                <tr className="text-white">
                                                    <td colSpan="4"></td>
                                                    <td><strong>Grand Total</strong></td>
                                                    <td><strong>${valueDay.dayWiseAmount.itemFinalTotal.toFixed(2)}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )
                        ))
                    }
                    <div className="table-responsive">
                        <table className="table table-bordered text-center">
                            <thead className="text-white">
                                <tr>
                                    <th colSpan="6" className="text-white p-3" style={{ background: "#db2727" }}>Order Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan="5" className="text-right"><strong>Sub Total</strong></td>
                                    <td>${parseFloat(multipleorderdetail?.finalSubTotal)?.toFixed(2) || "0.00"}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5">Discount</td>
                                    <td>${parseFloat(multipleorderdetail?.finalDiscount)?.toFixed(2) || "0.00"}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5">Coupon Discount</td>
                                    <td>${parseFloat(multipleorderdetail?.finalCouponDiscount)?.toFixed(2) || "0.00"}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5">Add On</td>
                                    <td>${parseFloat(multipleorderdetail?.finalAddOn)?.toFixed(2) || "0.00"}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5">Delivery Charges</td>
                                    <td>${parseFloat(multipleorderdetail?.finalDeliveryCharges)?.toFixed(2) || "0.00"}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5">GST</td>
                                    <td>${parseFloat(((multipleorderdetail?.finalTotal || 0) * 0.1)).toFixed(2)}</td>
                                </tr>
                                <tr className="text-white">
                                    <td colSpan="5"><strong>Final Total</strong></td>
                                    <td><strong>${parseFloat(multipleorderdetail?.finalTotal)?.toFixed(2) || "0.00"}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
                }
            </div>
        </div>
        </div>

        <Footer></Footer>
    </>)
}
export default Orderdetails